import { IconAtom, IconSize } from "../icon";
import styles from "./styles.module.scss";

export type StatusBadgeColor = "info" | "pending" | "success" | "error" | "neutral";

interface Props {
  label: string;
  icon: string;
  color: StatusBadgeColor;
  iconSize?: IconSize;
  hideLabel?: boolean;
}

const COLOR_CLASS: Record<StatusBadgeColor, string> = {
  info: styles.statusInfo,
  pending: styles.statusPending,
  success: styles.statusSuccess,
  error: styles.statusError,
  neutral: styles.statusNeutral,
};

export function StatusBadgeAtom({ label, icon, color, iconSize = "medium", hideLabel = false }: Readonly<Props>) {
  const badgeClass = [styles.statusBadge, COLOR_CLASS[color], hideLabel ? styles.iconOnly : ""].join(" ").trim();

  return (
    <span className={badgeClass}>
      <IconAtom icon={icon} size={iconSize} aria-hidden="true" />
      <span className={hideLabel ? styles.visuallyHidden : undefined}>{label}</span>
    </span>
  );
}
